import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";
import { api } from "@/lib/api";

const TYPE = { morning: "Mattino", focus: "Mezzogiorno", evening: "Sera" };
const MOMENT = { morning: "mattino", focus: "focus", evening: "sera" };

export function StagingPanel({ onChange }) {
  const [data, setData] = useState(null);
  const load = () => api.get("/c2g/notifications/preview").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const post = async (url, msg) => {
    try {
      await api.post(url);
      toast.success(msg);
      await onChange?.();
      await load();
    } catch {
      toast.error("Operazione non riuscita");
    }
  };

  if (!data?.staging) return null;
  return (
    <div className="mt-8 rounded-2xl border border-dashed border-[#F59E0B]/50 bg-[#F59E0B]/5 p-5" data-testid="c2g-staging-panel">
      <p className="flex items-center gap-2 text-[12px] font-semibold uppercase tracking-wider text-[#F59E0B]"><FlaskConical size={14} /> Versione di prova · strumenti di collaudo</p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button onClick={() => post("/c2g/test/advance-day", "Passato al giorno successivo")} data-testid="c2g-test-advance" className="rounded-full border border-[#3F3F46] px-3 py-2 text-sm font-semibold text-[#E4E4E7]">Vai al giorno dopo</button>
        <button onClick={() => window.confirm("Ricominciare la settimana da oggi con dati puliti?") && post("/c2g/test/reset", "Settimana ricominciata")} data-testid="c2g-test-reset" className="rounded-full border border-[#3F3F46] px-3 py-2 text-sm font-semibold text-[#E4E4E7]">Ricomincia settimana</button>
        <button onClick={() => window.confirm("Passare alla Settimana 1 da oggi con dati puliti?") && post("/c2g/test/set-week/1", "Ora sei nella Settimana 1")} data-testid="c2g-test-week1" className="rounded-full border border-[#3F3F46] px-3 py-2 text-sm font-semibold text-[#E4E4E7]">Vai alla Settimana 1</button>
        <button onClick={() => window.confirm("Passare alla Settimana 2 da oggi con dati puliti?") && post("/c2g/test/set-week/2", "Ora sei nella Settimana 2")} data-testid="c2g-test-week2" className="rounded-full border border-[#3F3F46] px-3 py-2 text-sm font-semibold text-[#E4E4E7]">Vai alla Settimana 2</button>
      </div>
      <p className="mt-4 text-sm font-semibold text-[#D4D4D8]">Notifiche del giorno {data.payloads[0]?.day_number} (simulate, nessun invio reale)</p>
      <ul className="mt-2 space-y-2">
        {data.payloads.map((p) => (
          <li key={p.type} className="rounded-xl bg-[#0D0D0F] p-3 text-sm" data-testid={`c2g-notif-${p.type}`}>
            <span className="font-semibold text-[#E5C158]">{TYPE[p.type]}</span>{" "}
            <span className={p.send ? "text-[#10B981]" : "text-[#F87171]"} data-testid={`c2g-notif-${p.type}-send`}>{p.send ? "verrebbe inviata" : `soppressa (${p.reason})`}</span>
            <p className="mt-1 text-[#B4B4BC]">{p.title} · {p.body}</p>
            <button onClick={() => post(`/c2g/test/simulate-notification/${MOMENT[p.type]}`, "Simulazione registrata")} data-testid={`c2g-notif-${p.type}-simulate`} className="mt-1 text-[12px] font-semibold text-[#D4AF37] underline">Simula l'orario</button>
          </li>
        ))}
      </ul>
      {data.log.length > 0 && (
        <div className="mt-4" data-testid="c2g-notif-log">
          <p className="text-sm font-semibold text-[#D4D4D8]">Registro simulazioni</p>
          <ul className="mt-1 space-y-1 text-[12px] text-[#8A8E96]">
            {data.log.map((l, i) => <li key={i}>{new Date(l.at).toLocaleString("it-IT")} · {l.channel} · {l.payload.type ? TYPE[l.payload.type] : l.payload.title} · {l.note}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
